import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { cloneBooking } from 'redux/booking/car/carBookingSlice';
import { Confirmation } from 'components/common';

const CloneBookingConfirm = ({ showModal, setshowModal, transaction }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeModal = () => setshowModal(false);

  const handleConfirm = async () => {
    try {
      const response = await dispatch(cloneBooking(transaction.id));
      const { data, message } = response.payload;

      closeModal();
      toast.success(message);

      if (data.id) navigate(`/booking/car/${data.id}`);
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Confirmation
      show={showModal}
      type="warning"
      title="Clone new car booking"
      message={`Are you sure to clone a new car booking from current booking number ${transaction.booking_number}?`}
      confirmText="Clone"
      cancelText="Cancel"
      onConfirm={handleConfirm}
      onCancel={closeModal}
    />
  );
};

CloneBookingConfirm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  transaction: PropTypes.object.isRequired,
};

export default CloneBookingConfirm;
